import {Organisation} from "../model/Organisation";

export class UpdateOrganisationDto extends Organisation {
  industryId: string;
}
